import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'enumkeyvalues',
})
export class EnumKeyValuesPipe implements PipeTransform {
  transform(value: any, ...args: any[]): any {
    return Object.keys(value)
      .filter(it => isNaN(Number(it)))
      .map(nextkey => {
        return {key: nextkey, value: value[nextkey]};
      });
  }
}
